import { Box, Grid, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import TaskInput from './TaskInput';
import TodosList from './TodosList';
import { v4 as uuidv4 } from 'uuid';
import { generateLoremIpsum } from '../../../../Utils/StringUtils';
import { getRandomNumber } from '../../../../Utils/NumberUtils';

export interface Todo {
  id: string;
  label: string;
  completed: boolean;
}

export enum TodoFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
}

export const TodoFilterLabel: Record<TodoFilter, string> = {
  [TodoFilter.ALL]: 'All',
  [TodoFilter.ACTIVE]: 'Active',
  [TodoFilter.COMPLETED]: 'Completed',
};

const generateInitialTodos = () => {
  const length = getRandomNumber(3, 20);
  // const length = 0;
  const initTodos = [];

  for (let x = 0; x < length; x++) {
    const obj = {
      id: uuidv4(),
      label: generateLoremIpsum(getRandomNumber(3, 10)),
      completed: getRandomNumber(0, 10) < 3 ? true : false,
      // completed: true,
    };
    initTodos.push(obj);
  }

  return initTodos;
};

const TodoList = () => {
  // const [todos, setTodos] = useState<Todo[]>([...INITIAL_TODOS]);
  const [todos, setTodos] = useState<Todo[]>([...generateInitialTodos()]);
  const [newTask, setNewTask] = useState('');
  const [filter, setFilter] = useState<TodoFilter>(TodoFilter.ALL);

  const handleAddTask = (text: string) => {
    setTodos((prev) => {
      return [{ id: uuidv4(), label: text, completed: false }, ...prev];
    });
  };

  const handleUpdateTask = (id: string) => {
    setTodos((prev) =>
      prev.map((todo) =>
        todo.id === id
          ? { ...todo, completed: !todo.completed } // ← create new object
          : todo
      )
    );
  };

  const clearCompleted = () => {
    setTodos((prev) => prev.filter((todo) => !todo.completed));
  };

  const toggleFilter = (value: TodoFilter) => {
    // setFilter((prev) =>
    //   prev === TodoFilter.ACTIVE ? TodoFilter.COMPLETED : TodoFilter.ACTIVE
    // );
    setFilter(value);
  };

  // The actual filtering logic
  const filteredTodos = todos.filter((todo: Todo) => {
    console.log('todo:', todo);
    console.log('filter:', filter);
    if (filter === TodoFilter.COMPLETED) {
      if (todo.completed) {
        return true;
      } else {
        return false;
      }
    } else if (filter === TodoFilter.ACTIVE) {
      if (todo.completed) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  });

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          height: '500px',
          width: '100%',
          // backgroundColor: '#8bcfffff',
          // background:
          //   'linear-gradient(135deg, #a5f3fc 0%, #67e8f9 50%, #22d3ee 100%)',
          background:
            'linear-gradient(120deg, #c7d2fe 0%, #a5f3fc 50%, #c084fc 100%)',
          // background:
          //   'linear-gradient(120deg, #c7d2fe 0%, #a5f3fc 50%, #c084fc 100%)',
          // background: 'linear-gradient(to bottom, #f0f9ff 0%, #e0f2fe 100%)',
          // background:
          //   'linear-gradient(45deg, #06b6d4 0%, #22d3ee 50%, #0ea5e9 100%)',
          // background:
          //   'linear-gradient(-45deg, #a5f3fc, #67e8f9, #22d3ee, #06b6d4)',
          // backgroundSize: '400% 400%',
          // animation: 'gradientFlow 18s ease infinite',
          // '@keyframes gradientFlow': {
          //   '0%, 100%': { backgroundPosition: '0% 50%' },
          //   '50%': { backgroundPosition: '100% 50%' },
          // },
          // background:
          //   'linear-gradient(135deg, #a5f3fc 0%, #67e8f9 50%, #22d3ee 100%)',
          // // Optional: add slight texture/overlay
          // backgroundImage:
          //   'linear-gradient(135deg, #a5f3fc 0%, #67e8f9 50%, #22d3ee 100%), radial-gradient(circle at 30% 20%, rgba(255,255,255,0.4) 0%, transparent 50%)',
        }}
      ></Box>
      <Grid
        container
        direction="row"
        gap={1}
        sx={(theme) => ({
          paddingTop: 10,
          paddingX: 2,
          zIndex: '10',
          minHeight: '1600px',
          width: '100%',
        })}
      >
        <Grid
          item
          lg={3} // takes 3 columns on lg+
          md={2} // optional: explicitly 0 on md (good practice)
          sm={false} // optional
          xs={false} // optional
          sx={{
            display: {
              xs: 'none', // hidden on extra-small & small
              sm: 'none', // hidden on small
              md: 'block', // hidden on medium
            },
          }}
        ></Grid>
        <Grid item sm={12} md={8} lg={6} sx={{ width: '100%' }}>
          <Stack
            direction="column"
            spacing={4}
            // className="w-full"
            sx={(theme) => ({
              paddingY: 2,
              marginBottom: '100px',
              width: '100%',
            })}
          >
            <Typography
              variant="h2"
              sx={{ color: '#fff', fontWeight: 'bold', paddingBottom: '20px' }}
            >
              T O D O s
            </Typography>
            <TaskInput
              value={newTask}
              onChange={setNewTask}
              onSubmit={handleAddTask}
              placeholder="Create a new todo..."
            />
            <Box
              sx={(theme) => ({
                // width: '100%',
                boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                backgroundColor: '#fff',
                borderRadius: '16px',
              })}
            >
              <TodosList
                todos={filteredTodos}
                handleUpdateTask={handleUpdateTask}
                toggleFilter={toggleFilter}
                clearCompleted={clearCompleted}
                filter={filter}
              />
            </Box>
          </Stack>
        </Grid>
        <Grid
          item
          lg={3} // takes 3 columns on lg+
          md={2} // optional: explicitly 0 on md (good practice)
          sm={false} // optional
          xs={false} // optional
          sx={{
            display: {
              xs: 'none', // hidden on extra-small & small
              sm: 'none', // hidden on small
              md: 'block', // hidden on medium
              // lg: 'block', // visible from lg and up
            },
          }}
        ></Grid>
      </Grid>
    </>
  );
};

export default TodoList;
